"use client";

import React, { useState } from "react";

type TabKey = "key" | "top";

const TABS: { key: TabKey; label: string }[] = [
    { key: "key", label: "Key Specs" },
    { key: "top", label: "Features" },
];

export default function KeySpecsClient({ children, showKeysTab = true, showFeaturesTab = true }: { children: React.ReactNode, showKeysTab?: boolean, showFeaturesTab?: boolean }) {
    const [tab, setTab] = useState<TabKey>("key");
    const visibleTabs = TABS.filter((t) => {
        if (t.key === "key" && !showKeysTab) return false;
        if (t.key === "top" && !showFeaturesTab) return false;
        return true;
    })
    return (
        <div data-active-tab={tab}>
            <div className="mb-3 mt-3">
                <div className="flex items-center gap-6 border-b border-gray-200">
                    {visibleTabs.map(({ key, label }) => (
                        <button
                            key={key}
                            onClick={() => setTab(key)}
                            className={`pb-2 text-sm ${tab === key ? "text-teal-600 border-b-2 border-teal-600" : "text-gray-600 hover:text-gray-800"}`}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>
            <div className="pt-2">{children}</div>
            <style jsx global>{`
                [data-active-tab] [data-tab-content]:not([data-tab-content="${tab}"]) { display: none; }
            `}</style>
        </div>
    );
}
